import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";

const LoadingSkeleton = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <React.Fragment>
      <SkeletonTheme color="#f5f7fa" highlightColor="#dde2eb">
        <div className="chat-list-loading-skeleton">
          <div className="chat-list">
            <section className="chat-list-head">
              <SearchInput
                Placeholder={translateText("search") + " ..."}
                OnChange={() => null}
              />

              <div className="dropdown-wrapper">
                <div className="dropdown-trigger" onClick={() => null}>
                  <h1 className="empty-title-skeleton"></h1>
                </div>
              </div>

              <div className="chat-list-tabs">
                <section
                  className="tab-item active-tab-item"
                  onClick={() => null}
                >
                  {translateText("jobs")}
                </section>
                <section className="tab-item" onClick={() => null}>
                  {translateText("projects")}
                </section>
                <section className="tab-item" onClick={() => null}>
                  {translateText("activities")}
                </section>
                <span></span>
              </div>
            </section>
            <div className="chat-items-wrapper">
              <div className="unpinned-chats">
                <div className="open-chat-skeleton">
                  <Skeleton
                    count={1}
                    height={23}
                    duration={0.8}
                    style={{
                      position: "absolute",
                      top: "12px",
                      left: " 16px",
                      width: "42%",
                    }}
                  />
                  <Skeleton
                    count={1}
                    height={23}
                    duration={0.8}
                    style={{
                      position: "absolute",
                      top: "12px",
                      right: " 16px",
                      width: "42%",
                    }}
                  />
                  <Skeleton
                    count={1}
                    height={48}
                    width={48}
                    duration={0.8}
                    style={{
                      position: "absolute",
                      top: "60px",
                      left: "40px",
                      borderRadius: "50%",
                    }}
                  />
                  <Skeleton
                    count={1}
                    height={23}
                    width={129}
                    duration={0.8}
                    style={{ position: "absolute", top: "60px", left: "96px" }}
                  />
                  <Skeleton
                    count={1}
                    height={23}
                    width={129}
                    duration={0.8}
                    style={{ position: "absolute", top: "86px", left: "96px" }}
                  />
                </div>
              </div>
              <div className="row-skeleton">
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={1}
                  duration={0.8}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="row-skeleton">
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={1}
                  duration={0.8}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="row-skeleton">
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={1}
                  duration={0.8}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="row-skeleton">
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={1}
                  duration={0.8}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="row-skeleton">
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={23}
                  duration={0.8}
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: " 16px",
                    width: "42%",
                  }}
                />
                <Skeleton
                  count={1}
                  height={1}
                  duration={0.8}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="message-list messages-skeleton">
          <React.Fragment>
            <section className="message-list-head">
              <Skeleton
                count={1}
                height={23}
                width={293}
                duration={0.8}
                style={{ marginLeft: "16px" }}
              />
              <span className="jpa-location">
                <Skeleton
                  count={1}
                  height={23}
                  width={132}
                  duration={0.8}
                  style={{ marginLeft: "60px" }}
                />
              </span>
              <i className="feather-more-vertical" onClick={() => null}></i>
            </section>
          </React.Fragment>

          <section className="messages">
            <div className="conversation-wrapper" id="conversation-wrapper">
              <div className="message-items">
                <div className="message-row">
                  <Skeleton
                    count={1}
                    height={32}
                    width={135}
                    duration={0.8}
                    style={{
                      display: "block",
                      margin: "auto auto auto 24px",
                      borderRadius: "4px 16px 16px 16px",
                    }}
                  />
                </div>
                <div className="message-row">
                  <Skeleton
                    count={1}
                    height={84}
                    width={406}
                    duration={0.8}
                    style={{
                      display: "block",
                      margin: "auto auto auto 24px",
                      borderRadius: "16px",
                    }}
                  />
                </div>
                <div className="message-row">
                  <Skeleton
                    count={1}
                    height={32}
                    width={135}
                    duration={0.8}
                    style={{
                      display: "block",
                      margin: "auto 24px auto auto",
                      borderRadius: "16px 4px 16px 16px",
                    }}
                  />
                </div>
                <div className="message-row">
                  <Skeleton
                    count={1}
                    height={84}
                    width={406}
                    duration={0.8}
                    style={{
                      display: "block",
                      margin: "auto 24px auto auto",
                      borderRadius: "16px",
                    }}
                  />
                </div>
              </div>
            </div>

            <React.Fragment>
              <section className="chat-actions">
                <p className="message-input-placeholder">
                  {translateText("icp_write_message")} ...
                </p>
                <div id="message-input-shadow" onChange={() => null}></div>
                <textarea
                  className="message-input"
                  id="message-input"
                  onChange={(e) => null}
                  onKeyDown={(e) => null}
                />
                <button className="send" onClick={() => null}>
                  <i className="feather-send"></i>
                </button>
              </section>
            </React.Fragment>
          </section>
        </div>
      </SkeletonTheme>
    </React.Fragment>
  );
};

export default LoadingSkeleton;
